<div
  class="configurable-cover"
  [class.configurable-cover--responsive-hero]="responsiveHeroFit"
  [ngClass]="cssClass"
  [style.background-image]="hasCustomCover ? 'none' : getBackgroundStyle()"
>
  <img
    *ngIf="hasCustomCover"
    class="configurable-cover__image"
    [src]="getCustomCoverUrl()"
    alt="Capa da empresa"
  />
  <ng-content></ng-content>
</div>
